import { Select } from 'common/components';
import { useMemo } from 'react';

// Default workflow option
export const DEFAULT_WORKFLOW_OPTION = { value: 'All Workflows', label: 'All Workflows' };

type Workflow = {
    id: string;
    title: string;
};

export const createWorkflowOptions = (dashboardData: { workflows: Workflow[] }) => {
    if (!Array.isArray(dashboardData?.workflows)) {
        return [DEFAULT_WORKFLOW_OPTION];
    }

    return [
        DEFAULT_WORKFLOW_OPTION,
        ...dashboardData.workflows.map((workflow) => ({
            value: workflow.id,
            label: workflow.title,
        })),
    ];
};

type WorkflowFilterProps = {
    selectedWorkflow: string;
    onWorkflowChange: (workflow: string) => void;
    dashboardData: any;
    isDashboardDataLoading: boolean;
};

export const WorkflowOptions = ({
    selectedWorkflow,
    onWorkflowChange,
    dashboardData,
    isDashboardDataLoading,
}: WorkflowFilterProps) => {
    const workflowOptions = useMemo(() => {
        if (isDashboardDataLoading) {
            return [DEFAULT_WORKFLOW_OPTION];
        }
        return createWorkflowOptions(dashboardData);
    }, [dashboardData, isDashboardDataLoading]);

    return (
        <div className='workflow-filter'>
            <Select
                value={selectedWorkflow}
                onChange={(e) => onWorkflowChange(e.target.value)}
                options={workflowOptions}
            />
        </div>
    );
};
